
export type IRegistrationService = RegistrationService;

export interface PasswordValidationResult {
    InvalidPassword?: boolean;
    Valid: boolean;
    Error?: string;
}

export class RegistrationService  {
    public static readonly $inject: string[] = [
        '$http',
        'settingsService'
    ];

    constructor(
        private readonly $http: ng.IHttpService,
        private readonly settings: any
    ) { }

    public validateRegistrationToken(authToken: string): ng.IPromise<any> {
        let uri = `${this.settings.serverAPIPath}/touch?auth=${authToken}`;
        return this.$http.get(uri);
    }

    public registerDeployment(deploymentId: string, authToken: string, username: string, password: string): ng.IPromise<any> {
        let uri = `${this.settings.serverAPIPath}/admin/registrations/${deploymentId}`;
        let userInfo = { UserName: username, Password: password };
        let headers = { Authorization: `PHOENIX-TOKEN ${authToken}` };
        return this.$http.post(uri, userInfo, { headers });
    }

    public validatePassword(password: string, authToken: string): ng.IPromise<PasswordValidationResult> {
        let uri = `${this.settings.serverAPIPath}/settings/passwordpolicy/test`;
        let data = { Password: password };
        let headers = { Authorization: `PHOENIX-TOKEN ${authToken}` };
        return this.$http
            .post(uri, data, { headers })
            .then((res) => res.data as PasswordValidationResult);
    }

    public registerUser(email: string, password: string, displayName: string, authToken: string): ng.IPromise<any> {
        let uri = `${this.settings.serverAPIPath}/registration?auth=${authToken}`;
        let data = {
            Email: email,
            Password: password,
            UserName: displayName
        };
        let headers = { Authorization: `PHOENIX-TOKEN ${authToken}` };

        return this.$http.post(uri, data, { headers });
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/services/registrationService.ts